import gql from 'graphql-tag';

export const SCHEDULING_SCHEDULED_MEMBER_FRAGMENT = gql`
  fragment SchedulingScheduledMember on Member {
    id
    firstName
    lastName
    memberGroupId
    positionId
    position {
      id
      level
      timeEvents
      viewSchedule
      manageSchedule
    }
  }
`;

export const SCHEDULING_TIME_OFF_FIELDS_FRAGMENT = gql`
  fragment SchedulingTimeOffFields on TimeOff {
    id
    dateStamp
    type
    description
    paid
    seconds
    memberId
    member {
      id
      ...SchedulingScheduledMember
    }
  }
  ${SCHEDULING_SCHEDULED_MEMBER_FRAGMENT}
`;
